module.exports = __webpack_public_path__ + "images/c804aee.jpg";